import generateImageUrl from 'utils/images/generateImageUrl';
import { BATCH_EDITOR_FIRST_OPEN, CDN_140 } from 'configs/constants';
import { IInfoPopupData } from 'components/common/InfoPopup/types';

const imageSize = 568;

const batchEditorInfoPopupData: IInfoPopupData = {
  id: '9c98c919-d2f3-4cb4-90e4-bddad06b789d',
  cookieName: BATCH_EDITOR_FIRST_OPEN,
  buttonName: 'Start Editing',
  slides: [
    {
      title: 'Edit Up to 50 Photos at Once',
      text: 'Use the Batch Editor to remove backgrounds, upscale, and resize your photos simultaneously.',
      src: generateImageUrl(`${CDN_140}/80239653004304766815.jpg`, imageSize),
    },
  ],
};

export {
  batchEditorInfoPopupData,
};
